import type { OwnerWaiting } from "@teamna/shared";

/** The days a name is placed on: the days of the coaches who added it, else every day of the level. */
export function daysFor(row: OwnerWaiting): number[] {
  if (row.defaultWeekdays.length > 0) return row.defaultWeekdays;
  return [...new Set(row.weeklyTimes.map((t) => t.weekday))].sort();
}
